import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    isDarkMode: false,
  }),
  
  actions: {
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode;
      const theme = this.isDarkMode ? 'ispmanager-dark' : 'ispmanager-light';
      localStorage.setItem('theme_manual', 'true');
      localStorage.setItem('theme', theme);
      document.documentElement.setAttribute('data-theme', theme);
      
      if (this.isDarkMode) {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
        document.body.classList.remove('light-mode');
        document.body.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.add('light');
        document.body.classList.remove('dark-mode');
        document.body.classList.add('light-mode');
      }
    },
    
    initTheme() {
      const themeVersion = localStorage.getItem('theme_version');
      const isManual = localStorage.getItem('theme_manual') === 'true';
      if (themeVersion !== '4.1' && !isManual) {
        localStorage.setItem('theme', 'ispmanager-light');
        localStorage.setItem('theme_version', '4.1');
      }

      let savedTheme = localStorage.getItem('theme');
      
      if (savedTheme === 'dark' || savedTheme === 'light') {
        savedTheme = savedTheme === 'dark' ? 'ispmanager-dark' : 'ispmanager-light';
        localStorage.setItem('theme', savedTheme);
      }
      
      if (!savedTheme) {
        savedTheme = 'ispmanager-light';
        localStorage.setItem('theme', savedTheme);
      }

      this.isDarkMode = savedTheme === 'ispmanager-dark';
      document.documentElement.setAttribute('data-theme', savedTheme!);
      
      if (this.isDarkMode) {
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
        document.body.classList.add('dark-mode');
        document.body.classList.remove('light-mode');
      } else {
        document.documentElement.classList.remove('dark');
        document.documentElement.classList.add('light');
        document.body.classList.add('light-mode');
        document.body.classList.remove('dark-mode');
      }
    }
  }
});
